import { createSelector } from '@opengov/compose-app/reselect';

import { accessTableSelector } from '../state/reportAccessTableState';

export const selectCurrentGrantees = createSelector(accessTableSelector, (state) => state.currentGrantees);

export const selectTemporaryGrantees = createSelector(accessTableSelector, (state) => state.temporaryGrantees);

export const selectInvitableUsers = createSelector(accessTableSelector, (state) => state.invitableUsers);

export const selectAccessTableStatus = createSelector(accessTableSelector, (state) => state.accessTableStatus);
